import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box, CircularProgress } from '@mui/material';
import LoginPage from './pages/LoginPage';
import Dashboard from './pages/Dashboard';
import LabResults from './pages/LabResults';
import Medication from './pages/Medication';
import Nutrition from './pages/Nutrition';
import Seizures from './pages/Seizures';
import Vaccination from './pages/Vaccination';
import VetSignUpPage from './pages/VetSignUpPage';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import VetProfile from './pages/VetProfile';
import VetPets from './pages/VetPets';
import About from './pages/About';
import Feedback from './pages/Feedback';
import NoPets from './pages/NoPets';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
});

// Protected Route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading screen while checking authentication
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#f5f5f5'
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<VetSignUpPage />} />
      <Route path="/" element={
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="lab-results" element={<LabResults />} />
        <Route path="medication" element={<Medication />} />
        <Route path="nutrition" element={<Nutrition />} />
        <Route path="seizures" element={<Seizures />} />
        <Route path="vaccination" element={<Vaccination />} />
        <Route path="profile" element={<VetProfile />} />
        <Route path="pets" element={<VetPets />} />
        <Route path="about" element={<About />} />
        <Route path="feedback" element={<Feedback />} />
        <Route path="no-pets" element={<NoPets />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
